export const practiceType = {
  homeHealth: 'Home Health',
  primaryCare: 'Primary Care',
  specialist: 'Specialist',
};


